import { css } from 'styled-components';
import { getSpacing, SpacingName, ThemedFunctor } from '@doveit/lego';

export const suggestionFooter: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, SpacingName.SMALLEST)}
  text-align: right;
`;
